import styled from 'styled-components'
import { containerDefault, containerHeadline } from '../../lib/styles/Container'
import { typoHeading3, typoHeading5, typoParagraphIntro } from '../../lib/styles/Typography'

export const Wrapper = styled.div`
  ${containerDefault}
  margin: 3rem auto;
`

export const Header = styled.div`
  ${containerHeadline}
  margin-bottom: 3rem;
`

export const Headline = styled.h2`
  ${typoHeading3}
  margin-bottom: 0.5rem;
`

export const Description = styled.div`
  ${typoParagraphIntro}
`

export const Body = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 3rem;
  row-gap: 4rem;

  @media screen and (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const Block = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 2rem;
  row-gap: 1.8rem;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`

export const BlockImage = styled.img`
  width: calc((100% - 2rem) * 0.22);
  flex: 0 0 auto;

  @media screen and (max-width: 1024px) {
    /* width: calc((100% - 2rem) * 0.4); */
    width: auto;
    height: 1.5rem;
  }

  @media screen and (max-width: 640px) {
    /* width: calc((100% - 2rem) * 0.22); */
  }

  @media screen and (max-width: 480px) {
    /* width: calc((100% - 2rem) * 0.3); */
    height: 1.2rem;
  }
`

export const BlockHeadline = styled.h3`
  ${typoHeading5}
  margin-bottom: 1rem;
`

export const BlockDescription = styled.div<{ hasButton: boolean }>`
  margin-bottom: ${({ hasButton }) => (hasButton ? '1.5rem' : '0')};
`
